import Vue from 'vue';
import auth from './auth';

const state = {
  statsPaths: {},
  statsFeatures: {},
  roomId: null,
};

const actions = {
  FETCH_STATS: async ({ commit }, { kuzzle, index }) => {
    //{ kuzzle, pathIdsList}) => {

    const searchOptions = {
      scroll: '1m',
    };

    let stats = await kuzzle.query({
      controller: 'document',
      action: 'search',
      index: index,
      collection: 'statsclient',
      from: 0,
      size: 100,
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
    });

    console.log('stats', stats.result.hits.length);
    commit('RESET_STATS');

    stats.result.hits.forEach((path) => {
      commit('SET_CURRENT_STATS', path);
    });
  },
  FETCH_STATS_FEATURES: async ({ commit }, { kuzzle }) => {
    const searchOptions = {
      scroll: '1m',
    };

    let featuresStats = [];

    // revoir search/filter
    let search = await kuzzle.document.search(
      'statistics',
      'features',
      {},
      searchOptions
    );

    while (search) {
      featuresStats.push(...search.hits);
      search = await search.next();
    }

    commit('RESET_STATS_FEATURES');
    featuresStats.forEach((feature) => {
      commit('SET_CURRENT_STATS_FEATURES', feature);
    });
  },
  SUBSCRIBE: async ({ commit }, { kuzzle, index }) => {
    const roomId = await kuzzle.realtime.subscribe(
      index,
      'statsclient',
      {
        loggedAsUser:
          auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      },
      (notification) => {
        switch (notification.action) {
          case 'create':
            commit('SET_CURRENT_STATS', notification.result.hits[0]._source);
            break;
          case 'update':
            commit('UPDATE_STATS', {
              pathId: notification.result._id,
              pathPayload: notification.result._source,
            });
            break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
  },
  SUBSCRIBE_FEATURES: async ({ commit }, { kuzzle }) => {
    const roomId = await kuzzle.realtime.subscribe(
      'statistics',
      'features',
      {},
      (notification) => {
        switch (notification.action) {
          case 'create':
            commit('ADD_FEATURE', notification.result);
            break;
          case 'update':
            commit('UPDATE_VOTE_STATS_FEATURES', {
              featureId: notification.result._id,
              featurePayload: notification.result._source,
            });
            break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  UNSUBSCRIBE_FEATURES: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  UPDATE_VOTE_STATS_FEATURES: async (
    {},
    { featureId, featurePayload, kuzzle }
  ) => {
    await kuzzle.document.update(
      'statistics',
      'features',
      featureId,
      featurePayload
    );
  },
  CREATE_FEATURE: async ({}, { newFeaturePayload, kuzzle }) => {
    await kuzzle.document.create('statistics', 'features', newFeaturePayload);
  },
  CREATE_STAT_DOC: async ({}, { pathId, index, kuzzle }) => {
    await kuzzle.query({
      controller: 'document',
      action: 'create',
      index: index,
      collection: 'statsclient',
      loggedAsUser:auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      body: {'nbUsers':[], 'missions':[]},
      _id:pathId
    });
},
  REMOVE_MISSION: async ({ state },
    { pathId, missionId, kuzzle, index }
  ) => {
    const missions = [
      ...state.statsPaths[pathId].missions.map((m) => ({ ...m })),
    ];
    let newMissionsList = missions.filter(
      (mission) => mission.missionId !== missionId
    );
    console.log('newmissions', newMissionsList.length);
    await kuzzle.document.update(index, 'statsclient', pathId, {
      missions: newMissionsList,
    });
  },
};

const mutations = {
  ADD_FEATURE: (state, feature) => {
    Vue.set(state.statsFeatures, feature._id, feature._source);
  },
  SET_CURRENT_STATS: (state, path) => {
    Vue.set(state.statsPaths, path._id, path._source);
  },
  SET_CURRENT_STATS_FEATURES: (state, feature) => {
    Vue.set(state.statsFeatures, feature._id, feature._source);
  },
  RESET_STATS: (state) => {
    state.statsPaths = {};
  },
  RESET_STATS_FEATURES: (state) => {
    state.statsFeatures = {};
  },
  UPDATE_STATS: (state, pathsPayload) => {},
  UPDATE_STATS_FEATURES: (state, pathsPayload) => {},
  UPDATE_VOTE_STATS_FEATURES: (state, { featureId, featurePayload }) => {
    console.log('mute UPDATE_VOTE_STATS_FEATURES');
    Vue.set(state.statsFeatures, featureId, featurePayload);
  },
  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

const getters = {
  getStatsPathById: (state) => {
    return (pathId) => {
      if (!Object.keys(state.statsPaths).includes(pathId)) {
        return null;
      }
      const path = state.statsPaths[pathId];
      return path;
    };
  },
  getStatsFeatureIdByName: (state) => {
    return (thisFeatureName) => {
      let thisFeatureId = '';
      Object.keys(state.statsFeatures).forEach((featureId) => {
        if (state.statsFeatures[featureId].name === thisFeatureName) {
          thisFeatureId = featureId;
        }
      });
      return thisFeatureId;
    };
  },
  getFeaturebyId: (state) => {
    return (featureId) => {
      if (!Object.keys(state.statsFeatures).includes(featureId)) {
        return null;
      }
      const feature = state.statsFeatures[featureId];
      return feature;
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
